import Entity from './entity';
import FlightReservationOrder from './flight/reservation/flightReservationOrder';
export default class Refund extends Entity<string> {
  orderId: string;
  paymentRule: number;
  total: number;
  passengers:FlightReservationOrder[];
}
